
















































































































































































































import { Component, Vue } from "vue-property-decorator";

import api from "@/network/api";
import { AxiosResponse } from "axios";
import VepContainer from "@/components/ui/VepContainer.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    VepContainer,
  },
  filters: {
    addSlashes(date: string) {
      if (date) {
        return date.split("-").join("/");
      }
    },
  },
})
export default class InfoDeskPage extends Vue {
  infoDesk: any = [];
  infoDeskDays: any = [];
  selectedDay = "";

  @Getter("eventTitle") private eventTitle!: string;

  created() {
    api.get("info_desk").then((res: AxiosResponse) => {
      this.infoDesk = res.data.info_desk;
      this.infoDeskDays = Object.keys(this.infoDesk);
      this.selectedDay = this.getTodayDate();
    });
  }

  nextDay() {
    let index = this.infoDeskDays.findIndex((day: any) => {
      return day == this.selectedDay;
    });

    if (index + 1 < this.infoDeskDays.length) {
      this.selectedDay = this.infoDeskDays[++index];
    }
  }

  prevDay() {
    let index = this.infoDeskDays.findIndex((day: any) => {
      return day == this.selectedDay;
    });

    if (index - 1 >= 0) {
      this.selectedDay = this.infoDeskDays[--index];
    }
  }

  getAvatar(trainer: any) {
    return trainer.avatar;
  }

  getTodayDate() {
    return new Date().toJSON().split("T")[0];
  }

  attend(session: any) {
    if ("trainer" in session) {
      api.post(`workshops/${session.id}/attend`);
    } else {
      api.post(`battles/${session.id}/attend`);
    }
  }
}
